var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_vm._v("\n  Application ("),_c('code',[_vm._v(_vm._s(_vm.$route.path))]),_vm._v(") not found.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }